// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609021434/js/" + chunkId + "." + {"44":"551ca4f0","225":"116b6dd1","481":"3f8d8a41","486":"8eab971b","770":"3a3fe13f"}[chunkId] + ".0.01273160443039778.chunk.js";
};